

export interface ITeacher {

    id: number,
    
    personId: number,
    registrationNumber: string,
    hiringDate: Date,
    status: string,
    statusDate: Date,

    lastDiploma: string,
    specialization: string,
    diplomaDate: Date,

    hasSubject: boolean,
    isDriver: boolean,    

    serviceCode: string,
    functionCode: string,
    employeeType: string,

    weeklyHours: number,
    schedulePreference: string,
    pedagogicalNotes: string,
    marietalStatus: string,
    numberOfDependents: number,
    serviceStartDate: Date,
    positionStartDate: Date,
    retirementDate: Date,
    firstServiceStartDate: Date,
    firstPositionStartDate: Date,
    previousInstitution: string,
    assignmentDecree: string,
    nominationDecree: string,
           
    firstName: string,
    lastName: string,
    particularSign: string,
    birthDate: Date,
    birthPlace: string,
    civility: string,
    gender: string,

    portable1: string,
    portable2: string,
    email1: string,
    email2: string,

    defaultLanguage: string,

    nationality: string,
    identificationType: string,
    identificationNumber: string, 
    identificationDelivrancePlace: string, 
    identificationStartDate: Date, 
    identificationEndDate: Date,

    ethnicityCode: string,
    base64Picture: string,

    birthCertificateDelivrancePlace: string,
    bloodType: string,
    rhesusFactor: string,
    chronicIllnessCode: string,
    hasSpecificNeeds: boolean,
    specificNeedPurposeCode: string,
    hasDisability: boolean,
    disabilityType: string,

    fatherId: number,
    motherId: number,
    tutorId: number,

    fatherCivility: string,
    motherCivility: string,
    tutorCivility: string,

    fatherGender: string,
    motherGender: string,
    tutorGender: string,

    fatherFirstName: string,
    motherFirstName: string,
    tutorFirstName: string,

    fatherLastName: string,
    motherLastName: string,
    tutorLastName: string,

    fatherBirthDate: Date,
    motherBirthDate: Date,
    tutorBirthDate: Date,

    fatherBirthPlace: string,
    motherBirthPlace: string,
    tutorBirthPlace: string,
    
    fatherParticularSign: string,
    motherParticularSign: string,
    tutorParticularSign: string,

    fatherBirthCertificateNumber: string,
    motherBirthCertificateNumber: string,
    tutorBirthCertificateNumber: string,

    fatherCivilRegistrar: string,
    motherCivilRegistrar: string,
    tutorCivilRegistrar: string,

    fatherName: string,
    motherName: string,
    tutorName: string,

    fatherPortable1: string,
    motherPortable1: string,
    tutorPortable1: string,

    fatherPortable2: string,
    motherPortable2: string,
    tutorPortable2: string,

    fatherEmail1: string,
    motherEmail1: string,
    tutorEmail1: string,

    fatherEmail2: string,
    motherEmail2: string,
    tutorEmail2: string,    

    // Just for ui.
    currentSchoolYearId: number,
    currentSchoolYearClassId: number,
    currentSchoolYearClassName: string,
    currentSchoolYearClassSubjectId: number
  }

  export interface ITeacherSheet {
    id: number,
    teacherId: number,
    schoolYearId: number,

    isCancelled: boolean,
    cancellationPurpose: string,
    type: 'disciplinary' | 'absence',
    absenceType: string,
    absencePurpose: string,
    absencePurposeDescription: string,
    justifedAbsence: boolean,
    disciplinaryType: string,
    disciplinaryEventSummary: string,
    disciplinaryEventDescription: string,
    disciplinaryEventDate: Date,
    observationPurpose: string,
    observationDescription: string,
    observationDate: Date
  }

  
  export const defaultTeacher : ITeacher = {
    id: 0,
    
    personId: 0,
    registrationNumber: '',
    hiringDate: new Date(),
    status: '10',
    statusDate: new Date(),

    lastDiploma: '',
    specialization: '',
    diplomaDate: new Date(),
    
    hasSubject: true,
    isDriver: false,
    
    serviceCode: '',
    functionCode: '',
    employeeType: '',

    weeklyHours: 0,
    schedulePreference: '',
    pedagogicalNotes: '',
    marietalStatus: '',
    numberOfDependents: 0,
    serviceStartDate: new Date(),
    positionStartDate: new Date(),
    retirementDate: new Date(),
    firstServiceStartDate: new Date(),
    firstPositionStartDate: new Date(),
    previousInstitution: '',
    assignmentDecree: '',
    nominationDecree: '',
    
    firstName: '',
    lastName: '',
    particularSign: '',
    birthDate: new Date(),
    birthPlace: '',
    civility: '',
    gender: '',
    
    portable1: '',
    portable2: '',
    email1: '',
    email2: '',

    defaultLanguage: '',

    nationality: '',
    identificationType: '',
    identificationNumber: '', 
    identificationDelivrancePlace: '', 
    identificationStartDate: new Date(), 
    identificationEndDate: new Date(),

    ethnicityCode: '',
    base64Picture: '',

    birthCertificateDelivrancePlace: '',
    bloodType: '',
    rhesusFactor: '',
    chronicIllnessCode: '',
    hasSpecificNeeds: false,
    specificNeedPurposeCode: '',
    hasDisability: false,
    disabilityType: '',

    fatherId: 0,
    motherId: 0,
    tutorId: 0,

    fatherCivility: 'Mr',
    motherCivility: 'Mme',
    tutorCivility: '',

    fatherGender: 'M',
    motherGender: 'F',
    tutorGender: '',


    fatherFirstName: '',
    motherFirstName: '',
    tutorFirstName: '',

    fatherLastName: '',
    motherLastName: '',
    tutorLastName: '',

    fatherBirthDate: new Date(),
    motherBirthDate: new Date(),
    tutorBirthDate: new Date(),

    fatherBirthPlace: '',
    motherBirthPlace: '',
    tutorBirthPlace: '',
    
    fatherParticularSign: '',
    motherParticularSign: '',
    tutorParticularSign: '',

    fatherBirthCertificateNumber: '',
    motherBirthCertificateNumber: '',
    tutorBirthCertificateNumber: '',

    fatherCivilRegistrar: '',
    motherCivilRegistrar: '',
    tutorCivilRegistrar: '',

    fatherName: '',
    motherName: '',
    tutorName: '',

    fatherPortable1: '',
    motherPortable1: '',
    tutorPortable1: '',

    fatherPortable2: '',
    motherPortable2: '',
    tutorPortable2: '',

    fatherEmail1: '',
    motherEmail1: '',
    tutorEmail1: '',

    fatherEmail2: '',
    motherEmail2: '',
    tutorEmail2: '',

    // Just for ui.
    currentSchoolYearId: 0,
    currentSchoolYearClassId: 0,
    currentSchoolYearClassName: '',
    currentSchoolYearClassSubjectId: 0
  }

  export const defaultTeacherSheet : ITeacherSheet = {
    id: 0,
    teacherId: 0,
    schoolYearId: 0,
    
    isCancelled: false,
    cancellationPurpose: '',
    type: 'disciplinary',
    absenceType: '',
    absencePurpose: '',
    absencePurposeDescription: '',
    justifedAbsence: false,
    disciplinaryType: '',
    disciplinaryEventSummary: '',
    disciplinaryEventDescription: '',
    disciplinaryEventDate: new Date(),

    observationPurpose: '',
    observationDescription: '',
    observationDate: new Date()
  }

  export interface ITeacherSearch {
    
    firstName: string,
    lastName: string,        
  }